module.exports = __webpack_public_path__ + "static/media/cover6.970781b3.jpeg";